import React, {useEffect, useState} from 'react';
import {connect} from "react-redux";
import logicGraphDataActions from "../../../../actions/logicGraphDataActions";
import defaultFieldModifierOption from "./FieldModifier/components/defaultFieldModifierOption";
import uniqueId from 'lodash/uniqueId';
import {ReactSortable} from 'react-sortablejs';
import {AddInputButton} from "../InputPortListUtils/components/AddInputButton";
import ContentWithTopLabel from "../ContentWithTopLabel";
import InputWithLabel from "../InputWithLabel";
import {OverwriteDynamicPropertyCheckbox} from "../InputPortListUtils/components/OverwriteDynamicPropertyCheckbox";
import {clickedNodeAction} from "../../../../actions/clickedNodeActions";
import Predicate from "../Predicate";
import FieldModifier from "./FieldModifier";
import {InputEntry} from "../InputPortListUtils/InputEntry";

const InputPortList = (props) => {
    const {clickedNode} = props;

    const nodeOptions = clickedNode.extras.options;
    const fieldModifierInfo = nodeOptions.fieldModifierInfo;
    const hasFuncs = nodeOptions && fieldModifierInfo;

    const [state, setState] = useState({
        compositeFieldName: hasFuncs ? fieldModifierInfo.compositeFieldName : "",
        portList: [],
        options: {
            inputPortData: [],
            logDecisionName: null,
            fieldModifierInfo: fieldModifierInfo,
            id: clickedNode.options.id,
            compositeFieldName: hasFuncs ? fieldModifierInfo.compositeFieldName : "",
            elementIdAutoIncrement: hasFuncs ? fieldModifierInfo.elementIdAutoIncrement : 0,
            overwriteDynamicProperty: hasFuncs ? fieldModifierInfo.overwriteDynamicProperty : true,
        },
        predicate: {
            type: "and",
            predicates: [
                {...defaultFieldModifierOption}
            ],
            alwaysTrue: true
        },
        modifier: hasFuncs ? (fieldModifierInfo.func ? fieldModifierInfo.func : fieldModifierInfo.modifier) : {
            funcName: "concat",
            funcArgs: []
        },
        elementIdAutoIncrement: hasFuncs ? fieldModifierInfo.elementIdAutoIncrement : 0,
        overwriteDynamicProperty: hasFuncs ? fieldModifierInfo.overwriteDynamicProperty : true,
    });

    useEffect(() => {
        createList();
    }, [])

    useEffect(() => {
        createOption();
    }, [state.options.inputPortData])

    const updateProperty = (property, value) => {
        let fieldModifierInfo = {...props.clickedNode}
        if (!Object.prototype.hasOwnProperty.call(fieldModifierInfo.extras, "options")) {
            fieldModifierInfo.extras.options.fieldModifierInfo = {};
        }
        fieldModifierInfo.extras.options.fieldModifierInfo = {
            ...state,
            [property]: value
        };

        setState({
            ...state,
            options: {
                ...state.options,
                [property]: value
            }
        });

        if (property === "overwriteDynamicProperty") {
            fieldModifierInfo.extras.options.overwriteDynamicProperty = value;
            fieldModifierInfo.extras.options.fieldModifierInfo.overwriteDynamicProperty = value;
            fieldModifierInfo.extras.options.fieldModifierInfo.options.overwriteDynamicProperty = value;
        }
        if (property === "compositeFieldName") {
            fieldModifierInfo.extras.options.compositeFieldName = value;
            fieldModifierInfo.extras.options.fieldModifierInfo.compositeFieldName = value;
            fieldModifierInfo.extras.options.fieldModifierInfo.options.compositeFieldName = value;
        }
        props.clickedNodeAction(fieldModifierInfo);
    }

    const updateOptionFieldName = (property, e) => {
        const value = e.target.value;
        state.compositeFieldName = value;
        updateProperty(property, value)
    }

    const onCheck = (e, property) => {
        const value = e.target.checked;
        state[property] = value
        updateProperty(property, value)
    }


    const onOptionsUpdate = (type, value, item) => {
        let fieldModifierInfo = {...props.clickedNode}

        const updatedItem = item;
        if (type === 'modifier') {
            updatedItem.modifier = value;
        }
        if (type === 'predicate') {
            updatedItem.predicate = value;
        }

        const updatedPortData = state.options.inputPortData.filter(port => port.id !== item.id ? port : item);

        if (!Object.prototype.hasOwnProperty.call(fieldModifierInfo.extras, "options")) {
            fieldModifierInfo.extras.options = {};
        }
        fieldModifierInfo.extras.options.fieldModifierInfo = {
            ...state,
            inputPortData: updatedPortData
        };
        setState({
            ...state,
            options: {
                ...state.options,
                inputPortData: updatedPortData
            }
        });

        props.clickedNodeAction(fieldModifierInfo);
    }

    const createList = () => {
        const engine = props.logicDataInfo
        const model = engine.getModel();
        const logicData = model.serialize();

        const clickedNodeModifierInfo = {...props.clickedNode};
        const portList = [];
        const inputPortData = clickedNodeModifierInfo.extras.options.inputPortData;


        Object.values(clickedNodeModifierInfo.ports).forEach((v, i) => {
            const predicate = JSON.parse(JSON.stringify(state.predicate));
            const modifier = JSON.parse(JSON.stringify(state.modifier));
            const values = {
                logDecisionValue: '',
                predicate: predicate,
                modifier: modifier,
                overwriteDynamicProperty: props.clickedNode.options.overwriteDynamicProperty,
                compositeFieldName: props.clickedNode.options.compositeFieldName,
            };

            if (typeof inputPortData !== 'undefined' && inputPortData.length > 0 && v.options.in) {
                values.logDecisionValue = typeof inputPortData[i] !== 'undefined' ? inputPortData[i].logDecisionValue : '';
                values.compositeFieldName = typeof inputPortData[i] !== 'undefined' ? inputPortData[i].compositeFieldName : true;
                values.overwriteDynamicProperty = typeof inputPortData[i] !== 'undefined' ? inputPortData[i].overwriteDynamicProperty : true;
                values.predicate = typeof inputPortData[i] !== 'undefined' ? inputPortData[i].predicate : predicate;
                values.modifier = typeof inputPortData[i] !== 'undefined' ? inputPortData[i].modifier : modifier;
            }

            const createData = {
                parentID: clickedNodeModifierInfo.options.id,
                id: v.options.id,
                nodeName: 'Empty Modifier',
                branchName: '',
                index: 0,
                edit: false,
                sectionType: 'empty',
                logDecisionValue: values.logDecisionValue,
                predicate: values.predicate,
                modifier: values.modifier,
                overwriteDynamicProperty: values.overwriteDynamicProperty,
                compositeFieldName: values.compositeFieldName,
                in: v.options.in
            }

            if (v.connection) {
                let nodeID = '';
                Object.values(logicData.layers.filter(layer => layer.type === 'diagram-links')[0].models).forEach(link => {
                    if (link.sourcePort === v.options.id) {
                        nodeID = link.target;
                    }
                    if (link.targetPort === v.options.id) {
                        nodeID = link.source;
                    }
                });
                const nodeData = Object.values(logicData.layers.filter(layer => layer.type === 'diagram-nodes')[0].models).filter(node => node.id === nodeID)[0]
                createData.nodeName = nodeData.name;
                createData.sectionType = nodeData.sectionType;
                createData.index = i
                portList.push(createData);
            } else {
                createData.index = i;
                portList.push(createData);
            }
        });

        const newPortList = [];
        const inputPortList = portList.filter(port => port.in);
        const outputPortList = portList.filter(port => port.in === false);
        inputPortList.forEach((v, i) => {
            v.index = i;
            newPortList.push(v);
        });
        outputPortList.forEach((v) => {
            newPortList.push(v);
        });

        state.portList = newPortList;
        state.options.inputPortData = inputPortData !== undefined ? inputPortData : [];
        state.compositeFieldName = clickedNodeModifierInfo.extras.options.compositeFieldName;
        state.overwriteDynamicProperty = clickedNodeModifierInfo.extras.options.overwriteDynamicProperty;

    }

    const createOption = () => {
        const inputPortData = Object.values({...state.options.inputPortData});

        const options = {...state.options};
        options.inputPortData = inputPortData;
        options.logDecisionName = props.clickedNode.extras.options.logDecisionName;
        options.overwriteDynamicProperty = props.clickedNode.extras.options.overwriteDynamicProperty;
        options.compositeFieldName = props.clickedNode.extras.options.compositeFieldName;

        const logicGraphData = {
            options: options,
            portList: state.portList,
            id: props.clickedNode.options.id,
            overwriteDynamicProperty: props.clickedNode.options.overwriteDynamicProperty,
            compositeFieldName: props.clickedNode.options.compositeFieldName
        }
        props.logicGraphDataActions(logicGraphData);
    }

    const removeInputPort = (item) => {
        const portList = state.options.inputPortData;
        const newInputPortList = portList.filter(port => port.id !== item.id);
        for (let i = 0; i < newInputPortList.length; i++) {
            newInputPortList[i].id = i;
        }
        setState({
            ...state,
            options: {
                ...state.options,
                inputPortData: newInputPortList
            }
        });
    }

    const addModifier = () => {
        const inputPortData = state.options.inputPortData;
        const newModifier = {
            predicate: state.predicate,
            modifier: state.modifier,
            alwaysTrue: false,
            logDecisionValue: '',
            id: inputPortData.length,
            edit: false,
        }
        inputPortData.push(newModifier)

        setState({
            ...state,
            options: {
                ...state.options,
                inputPortData: inputPortData
            },
        });
    }

    const editInputButton = (item) => {
        const setEditValue = editModifierButton(state.options.inputPortData, item);
        setState({
            ...state,
            options: {
                ...state.options,
                inputPortData: setEditValue
            }
        });
    }

    function editModifierButton(portListData, item) {
        const portList = Object.assign({}, portListData);
        return Object.values(portList).map((v) => {
            if (v.id === item.id)
                v.edit = !v.edit;
            return v;
        });
    }

    const inputHandle = (event, item, name) => {
        let process = false;
        const portList = {...state.options.inputPortData};
        const setInputData = Object.values(portList).map((v) => {
            if (v.id === item.id) {
                if (name === 'logDecisionValue' && v.logDecisionValue !== event.target.value) {
                    v.logDecisionValue = event.target.value;
                    process = true;
                }
            }
            return v;
        });
        if (process) {
            setState({
                ...state,
                options: {
                    ...state.options,
                    inputPortData: setInputData
                }
            });
        }
    }

    const defaultPort = (data) => {
        if (data.length === 0) return [];
        return data.map((val) => {
            return (
                <InputEntry value={val} key={val.id}
                            removePort={removeInputPort}
                            inputHandle={inputHandle}
                            editButton={editInputButton}>
                    <Predicate updateOptions={(predicate) => onOptionsUpdate("predicate", predicate, val)}
                               predicate={val.predicate} hasInputCount/>
                    <FieldModifier
                        updateOptions={(funcName) => onOptionsUpdate("modifier", funcName, val)}
                        modifier={val.modifier}
                        updateProperty={updateProperty}
                    />
                </InputEntry>
            )
        })
    }

    const groupCreate = () => {
        const portListData = state.options.inputPortData;

        const roundRobin = portListData.filter(port => port.roundRobin).length > 0 ? 'round-robin' : '';
        return (
            <ReactSortable key="static"
                           animation={150}
                           handle='.drag-handle'
                           group={'default_group' + uniqueId()}
                           pull={true}
                           put={true}

                           list={portListData}
                           setList={(newState) => {
                               if (portListData.length !== newState.length || !portListData.every((val, index) => val === newState[index])) {
                                   const newPortList = [...newState];
                                   newPortList.forEach((val, key) => {
                                       val.id = key;
                                       return val;
                                   });
                                   setState({
                                       ...state,
                                       options: {
                                           ...state.options,
                                           inputPortData: newPortList
                                       }
                                   });
                               }
                           }}
                           className={`list-area ${roundRobin} group-${portListData.length ? portListData[0].groupID : ''}`}
            >
                {defaultPort(portListData)}
            </ReactSortable>
        )
    }

    return (
        <div>
            <ContentWithTopLabel label="Field name">
                <InputWithLabel
                    label="New Composite field name:"
                    handleChange={e => updateOptionFieldName('compositeFieldName', e)}
                    value={state.compositeFieldName}
                />
                <OverwriteDynamicPropertyCheckbox
                    label={"Overwrite Dynamic Property"}
                    isChecked={state.overwriteDynamicProperty}
                    onCheck={onCheck}
                    name={"overwriteDynamicProperty"}
                />
            </ContentWithTopLabel>
            <ContentWithTopLabel label="Modifier"/>
            <div className="node-input-list">
                {
                    state.portList && groupCreate()
                }
                <AddInputButton onClick={addModifier}/>
            </div>
        </div>
    )
}

function mapStateToProps(state) {
    return {
        clickedNodeInfo: state.clickedNodeInfo,
        logicDataInfo: state.logicDataInfo,
        logicGraphData: state.logicGraphData
    }
}

export default connect(mapStateToProps, {logicGraphDataActions, clickedNodeAction})(InputPortList);
